import noop from 'lodash/noop';
import { createActions } from 'redux-actions';

export const templatesActions = createActions(
  {
    TEMPLATES_RENDER: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
  },
  'TEMPLATES_RENDER_SUCCEEDED',
  'TEMPLATES_RENDER_FAILED',
);
